import {
  ErrorHandler,
  forwardRef,
  Inject,
  Injectable,
  InjectionToken,
  Optional,
} from '@angular/core';

import { Router } from '@angular/router';
import { Injector } from '@angular/core';
import { AppRestartService } from '../shared/services/index';

export interface ErrorLoggingService {
  error: Function;
}

export const ERROR_LOGGING_SERVICE = new InjectionToken<ErrorLoggingService>(
  'NFErrorHandler Logging Service'
);

@Injectable()
export class NFErrorHandler implements ErrorHandler {
  private errorRaised = false;
  constructor(private injector: Injector) {}

  async handleError(error) {
    if (!this.errorRaised) {
      console.error(error);
      try {
        const loggingService = this.injector.get(ERROR_LOGGING_SERVICE);
        if (loggingService) {
          loggingService.error(error);
        }
      } catch (e) {
        // injector.get throws an exception if we can't find a logging service
      }

      this.errorRaised = true;
      const restarter = this.injector.get(AppRestartService);
      if (restarter) {
        restarter.requestRestart();
      }
    }
  }
}
